import type { CartError } from 'models/api';

import type { CheckoutMachineState } from './checkout.machine';

export const selectPaymentActor = (state: CheckoutMachineState) =>
	state.context.paymentActor;

export const selectDeliveryActor = (state: CheckoutMachineState) =>
	state.context.deliveryActor;

export const selectUserInfoActor = (state: CheckoutMachineState) =>
	state.context.userInfoActor;

export const selectGiftCardBonusActor = (state: CheckoutMachineState) =>
	state.context.giftCardBonusActor;

export const selectCartIsReady = (state: CheckoutMachineState) =>
	!state.matches('loadCart');

export const selectCartHasLoaded = (state: CheckoutMachineState) =>
	Boolean(state.context.data?.id);

export const selectCartData = (state: CheckoutMachineState) =>
	state.context.data;

export const selectIsInErrorState = (state: CheckoutMachineState) =>
	state.matches('error');

export const selectAllowGiftCard = (state: CheckoutMachineState) =>
	Boolean(state.context.data?.allowGiftCard);

export const selectPayButtonState = (state: CheckoutMachineState) =>
	state.context.payButtonState;

export const selectBasketRows = (state: CheckoutMachineState) =>
	state.context.data?.basketRows;

export const selectCheckoutStatus = (state: CheckoutMachineState) =>
	state.context.data?.checkoutStatus;

export const selectShowNotification = (state: CheckoutMachineState) =>
	state.context.showNotification;

export const selectTotalSummary = (state: CheckoutMachineState) =>
	state.context.data?.totalSummary;

export const selectSavingTotalSumSummary = (state: CheckoutMachineState) =>
	state.context.data?.savingSummaries.find(
		(summary) => summary.sumType === 'SavingTotalSum',
	);

export const selectErrorList = (
	state: CheckoutMachineState,
): CartError[] | undefined => state.context.data?.errorList;
export const selectCheckoutErrorMessages = (state: CheckoutMachineState) =>
	state.context.checkoutErrorMessages;

export const selectHasForbiddenCartError = (state: CheckoutMachineState) =>
	state.hasTag('hasForbiddenCartError');
